import { render } from "./EmailBrandingDrawer.vue?vue&type=template&id=73c999ad&scoped=true&ts=true"
import script from "./EmailBrandingDrawer.vue?vue&type=script&lang=ts"
export * from "./EmailBrandingDrawer.vue?vue&type=script&lang=ts"

import "./EmailBrandingDrawer.vue?vue&type=style&index=0&id=73c999ad&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c999ad"]])

export default __exports__